import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import { Container } from "./styles";
import dellIcon from "../../assets/icons/dell-logo.svg";
import backIcon from "../../assets/icons/back-arrow-filled.svg";
import { useCallback, useEffect, useState } from "react";
import { Sidebar } from "../../components/SideBar";
import { AccessibilityPopup } from "../../components/AccessibilityPopup";

interface Person {
  name: string;
  role: string;
}

export function NossoTime() {
  const navigate = useNavigate();
  useState
  const [showSidebar, setShowSidebar] = useState(false);
  const [isAccessibilityOpen, setIsAccessibilityOpen] = useState(false);


  const people: Person[] = [
    { name: "Micarla da Silva", role: "Production & Assembly Representative" },
    { name: "Kleidson Luiz de Sousa", role: "Production & Assembly Representative" },
    { name: "Bruno dos Santos", role: "Production & Assembly Senior Representative" },
    { name: "Marcela Ramos", role: "Production & Assembly Representative" },
    { name: "Claudia Costa", role: "Production & Assembly Representative" },
    { name: "Vanessa Silva", role: "Production & Assembly Representative" },
    { name: "Esau Nascimento", role: "Production & Assembly Representative" },
    { name: "Andrea Nunes", role: "Production & Assembly Representative" },
    { name: "Mariane de Castro", role: "Production & Assembly Representative" },
    { name: "Carolina Souza", role: "Production & Assembly Representative" },
    { name: "Thayse Soares", role: "Production & Assembly Representative" },
    { name: "José Linhares", role: "Production & Assembly Representative" },
    { name: "Renato Rodrigues", role: "Production & Assembly Representative" },
  ];

  const handleLibrasSelection = useCallback((detection: string) => {
    if (detection === 'voltar') {
      navigate("/home");
    }
  }, []);

  useEffect(() => {
    const onLibrasEvent = (event: any) => {
      const num = event.detail.number;
      handleLibrasSelection(num);
    };

    window.addEventListener("LIBRAS_SELECTION", onLibrasEvent);

    return () => {
      window.removeEventListener("LIBRAS_SELECTION", onLibrasEvent);
    };
  }, [handleLibrasSelection]);

  return (
    <>
      <Header
        toggleSidebar={() => setShowSidebar(!showSidebar)}
        onBack={() => { }}
        onEvalClick={() => { }}
        onImportClick={() => { }}
        showSidebar={showSidebar}
        isAccessibilityOpen={isAccessibilityOpen}
        setIsAccessibilityOpen={setIsAccessibilityOpen}
        backToHome={()=>navigate("/home")}
        Aimode={false}
        closeAimode={()=>{}}
      />

      <Sidebar
        open={showSidebar}
        onClose={() => setShowSidebar(false)}
      />

      <AccessibilityPopup
        isOpen={isAccessibilityOpen}
        onClose={() => setIsAccessibilityOpen(false)}
      />

      <Container>

        <img src={dellIcon} alt="Logo da Dell" className="LogoDell" />

        <p className="Comments">
          Conheça quem contribuiu ativamente do processo colaborativo da solução e fez a diferença.
        </p>

        <p className="Version"><strong>Versão {process.env.REACT_APP_VERSION}</strong></p>

        <div className="TableHeader">
          <p><strong>Nome</strong></p>
          <p><strong>Cargo</strong></p>
        </div>

        <div className="TableBody">
          {people.map((person, index) => (
            <div
              key={index}
              className={`Row ${index < 2 ? "GroupedFirstTwo" : ""} ${index === 1 ? "SecondOfGroup" : ""}`}
            >
              <p>{person.name}</p>
              <p>{person.role}</p>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
}
